import ReactCountryFlag from 'react-country-flag'

const Flag = (props) => {
    
    return (
        <ReactCountryFlag countryCode={props.country} svg className='mr-1'/>
    )
}

export default Flag